<template>
  <div class="shotlist">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row shot-back-button">
        <div class="col">
          <router-link :to="'/jobs/' + eventId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
        </div>
      </div>
      <div class="row mb-x2">
        <div class="col">
          <div class="h6">
            {{ eventData.event_name }}
          </div>
          <div class="d-flex align-items-center">
            <h2>{{ shotlistTitle }}</h2>
            <div class="zero-badge ml-x1">
              {{ filteredResults.length }}
            </div>
          </div>
        </div>
      </div>
      <template v-if="!this.generalShots">
        <div class="row mb-x2 shot-sticky-creatives">
          <div class="col">
            <h6>Creatives</h6>
            <CreativesList v-if="users.length !== 0" :allUsers="users" :creatives="eventData.creatives" filter @filterEmit="creativeFilter" :activeFilters="filteredCreatives"/>
          </div>
        </div>
        <div class="row mb-x2 shot-sticky-dates">
          <div class="col">
            <h6>Dates</h6>
            <DatesList v-if="eventData.days.length !== 0" :dates="eventData.days" @filterEmit="dateFilter" :activeFilters="filteredDates"/>
          </div>
        </div>
        <div class="row mb-x4">
          <div class="col-md-8 col-lg-6">
            <div class="zero-card mb-x2" v-for="(shot, index) in filteredResults" :key="index">
              <p class="shot-date">{{ getDayofWeek(shot.date) }} {{ parseDate(shot.date) }}</p>
              <h5>{{ amPmConvert(shot.start_time) }} - {{ amPmConvert(shot.end_time) }}</h5>
              <CreativesList includeName v-if="users.length !== 0" :allUsers="users" :creatives="shot.creatives" />
              <div class="shot-info-group" v-if="shot.location">
                <div class="shot-label">location</div>
                <p>{{ shot.location }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.event">
                <div class="shot-label">event/session</div>
                <p>{{ shot.event }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.contact">
                <div class="shot-label">session contact</div>
                <p>{{ shot.contact }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.notes">
                <div class="shot-label">CSV notes</div>
                <p>{{ shot.notes }}</p>
              </div>
              <NoteEditor :id="shot.id" :notesProp="shot.extraone" :jwt="userToken" class="mr-x2" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row mb-x4">
          <div class="col-md-8 col-lg-6">
            <div class="zero-card mb-x2" v-for="(shot, index) in filteredResults" :key="index">
              <div class="d-flex">
                <div>
                  <ToDoClick :id="shot.id" :done="shot.done" :jwt="userToken" class="mr-x2" />
                </div>
                <div class="pre-wrap">{{ shot.notes }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- FABS -->
    <button @click="backToTop" class="zero-btn zero-btn-fab zero-btn-primary bottom-right">
      <i class="fas fa-arrow-up"></i>
    </button>
    <!-- modal town -->
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import DatesList from '@/components/DatesList.vue'
import PageLoader from '@/components/PageLoader.vue'
import ToDoClick from '@/components/ToDoClick.vue'
import NoteEditor from '@/components/NoteEditor.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    DatesList,
    PageLoader,
    ToDoClick,
    NoteEditor
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      eventData: {
        'event_name': '',
        'days': [],
        'location': '',
        'floorplan_path': ''
      },
      shots: [],
      uploadCSVmodal: false,
      errors: {
        'file': ''
      },
      users: [],
      shotlistTitle: 'Shotlist',
      generalShots: false,
      filteredCreatives: [],
      filteredDates: [],
      filteredResults: [],
      editNotes: false
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.path.includes('general')) {
        this.generalShots = true
        this.shotlistTitle = 'General Shots'
        this.getGeneralShots()
      } else {
        this.generalShots = false
        this.shotlistTitle = 'Shotlist'
        this.getShotlist()
      }
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.eventId = this.$route.params.eventid
      this.getEvent()
      this.getUsers()
    }
    if (this.$route.path.includes('general')) {
      this.generalShots = true
      this.shotlistTitle = 'General Shots'
      this.getGeneralShots()
    } else {
      this.generalShots = false
      this.shotlistTitle = 'Shotlist'
      this.getShotlist()
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getShotlist () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId + '/shotlist', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.shots = response.data
          this.combineFilters()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getGeneralShots () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId + '/general', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.filteredResults = response.data
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getUsers () {
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment, true)
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    creativeFilter (clickedCreative) {
      if (this.filteredCreatives.includes(clickedCreative)) {
        this.filteredCreatives = this.filteredCreatives.filter((filteredCreative) => filteredCreative !== clickedCreative)
      } else {
        this.filteredCreatives.push(clickedCreative)
      }
      this.combineFilters()
    },
    dateFilter (clickedDate) {
      if (this.filteredDates.includes(clickedDate)) {
        this.filteredDates = this.filteredDates.filter((filteredDate) => filteredDate !== clickedDate)
      } else {
        this.filteredDates.push(clickedDate)
      }
      this.combineFilters()
    },
    combineFilters () {
      this.isLoading = true
      if (this.filteredDates.length > 0) {
        this.filteredResults = this.shots.filter((shot) => this.filteredDates.some(filteredDate => shot.date === filteredDate))
      } else {
        this.filteredResults = this.shots
      }
      if (this.filteredCreatives.length > 0) {
        this.filteredResults = this.filteredResults.filter((shot) => this.filteredCreatives.some(filteredCreative => shot.creatives.replace(/\s+/g, '').split(',').includes(filteredCreative)))
      }
      this.isLoading = false
    },
    getDayofWeek (date) {
      let dateVal = new Date(date)
      let dayInt = dateVal.getUTCDay()
      let week = ['sun', 'mon', 'tue', 'wed', 'thur', 'fri', 'sat']
      if (isNaN(dayInt) && dayInt < 7) {
        return ''
      } else {
        return week[dayInt]
      }
    },
    backToTop () {
      // this one is needed for safari apparently
      document.body.scrollTop = 0
      // for all other browsers
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.tab-content .menu-info{
  h2{
    display: block;
  }
}
.desktop-button{
  display: none;
}
.mobile-button {
  display: flex;
  &.csv-fab{
    right: 100px;
  }
}

// sticky items
.shot-back-button{
  position: sticky;
  top: 0px;
  padding-top: 24px;
  margin-top: -24px;
  z-index: 10;
  background: $color-bg-1;
}
.shot-sticky-creatives{
  position: sticky;
  top: 76px;
  z-index: 10;
  background: $color-bg-1;
}
.shot-sticky-dates{
  position: sticky;
  top: 154px;
  z-index: 10;
  background: $color-bg-1;
  box-shadow: 0px 8px 12px -8px rgba(0,0,0,0.1);
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .desktop-button{
    display: inline-block;
  }
  .mobile-button {
    display: none;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
